import { render, staticRenderFns } from "./adminRoomList.vue?vue&type=template&id=cbafc3e0&scoped=true"
import script from "./adminRoomList.vue?vue&type=script&lang=js"
export * from "./adminRoomList.vue?vue&type=script&lang=js"
import style0 from "./adminRoomList.vue?vue&type=style&index=0&id=cbafc3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbafc3e0",
  null
  
)

export default component.exports